import React from "react"
import Item from "./item"

const BlogPostTopItem = () => {
  return (
    <Item
      title="HEADのGRAVITY MPがカッコよすぎて買ったら最高だった"
      des="HEADのGRAVITYの新作が発売されました。グラビティはストローク主体の人にオススメのラケットです。ラケットフェイスの形が独特ですが、慣れるとこれが最高に見えてきます。"
      image="https://ws-fe.amazon-adsystem.com/widgets/q?_encoding=UTF8&ASIN=B0BY1Z64B6&Format=_SL160_&ID=AsinImage&MarketPlace=JP&ServiceVersion=20070822&WS=1&tag=poppotennis09-22&language=ja_JP"
      amazon="https://amzn.to/3q60SJ6"
      rakuten="https://rpx.a8.net/svt/ejp?a8mat=2ZNP44+2FITSI+2HOM+BWGDT&rakuten=y&a8ejpredirect=https%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r3jp4.2bo11c31.g00r3jp4.2bo12562%2Fa18082404583_2ZNP44_2FITSI_2HOM_BWGDT%3Fpc%3Dhttps%253A%252F%252Fitem.rakuten.co.jp%252Fhimaraya%252F0000001096138%252F%26amp%3Bm%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fhimaraya%252Fi%252F10533739%252F"
    />
  )
}
export default BlogPostTopItem
